import React from 'react';
import { css } from 'glamor';
import map from 'lodash/map';
import { Watch } from 'scrollmonitor-react';

import Image from '../Image';
import AnimationWrapper from '../AnimationWrapper';
import { textContainer } from '../../styles';

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {
    this.props.loadTheme();
  }

  getBlomHeader = index => {
    return [
      {
        srcSet: require(`../../assets/blom/blom-a-generative-art-series-by-lucastswick-thumb-${index}.jpg`),
        media: '(max-width: 100px)',
      },
      {
        srcSet: require(`../../assets/blom/blom-a-generative-art-series-by-lucastswick-sm-${index}.jpg`),
        media: '(max-width: 720px)',
      },
      {
        srcSet: require(`../../assets/blom/blom-a-generative-art-series-by-lucastswick-${index}.jpg`),
      },
    ];
  };

  componentWillReceiveProps(nextProps) {
    const { theme } = nextProps;
    if (theme && theme.blomIndex) {
      const sampledImage = this.getBlomHeader(theme.blomIndex);
      this.setState({ sampledImage });
    }
  }

  render() {
    const { theme, isInViewport } = this.props;
    const { sampledImage } = this.state;

    return (
      <div {...textContainer}>
        <AnimationWrapper
          inProp={isInViewport}
          transitionName="slideUp"
          delay={150}
          once
        >
          <h2>Why is the website a little different every time I refresh?</h2>
        </AnimationWrapper>
        <AnimationWrapper
          inProp={isInViewport}
          transitionName="slideUp"
          delay={250}
          once
        >
          <p>
            A big thing that makes generative art unique is that part of the
            process is not in the artist's hands. For me, that means I use random
            numbers a bunch in my work.
          </p>
        </AnimationWrapper>
        <AnimationWrapper
          inProp={isInViewport}
          transitionName="slideUp"
          delay={350}
          once
        >
          <p>
            Case in point: everytime this website is loaded, it chooses a new
            image (below, left) and finds the most vibrant color. Then a color
            scheme is built using that color, shown on the right. Every visit gets
            a different image and a different color theme. It's always changing!
          </p>
        </AnimationWrapper>
        <AnimationWrapper
          inProp={isInViewport}
          transitionName="slideUp"
          delay={450}
          once
        >
          <div {...css({ display: 'flex' })}>
            <div {...css({ flex: '1 0 50%' })}>
              <Image sources={sampledImage} theme={theme} />
            </div>
            <div
              {...css({
                display: 'inline-flex',
                flexWrap: 'wrap',
                flexDirection: 'column',
                flex: '1 0 50%',
              })}
            >
              {map(theme.colors, (col, index) => {
                return (
                  <span
                    key={`col-${index}`}
                    {...css({
                      width: '100%',
                      backgroundColor: col,
                      flex: '1 0 auto',
                    })}
                  />
                );
              })}
            </div>
          </div>
        </AnimationWrapper>
      </div>
    );
  }
}

About.defaultProps = {
  theme: { colors: ['#fff', '#333', '#444'] },
};
export default Watch(About);



// WEBPACK FOOTER //
// ./src/components/About/About.js